import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Avatar from '../Avatar';

const UserInfo = ({
  avatarSrc,
  avatarInitials,
  title,
  subtitle,
  isOnline,
  deactivated,
  className,
  avatarSize,
  role,
  titleCn,
  subtitleCn,
  children,
  ...props
}) => {
  const cn = classNames(['inline-flex', 'items-center', 'overflow-hidden', className]);
  const titleClassNames = classNames(['leading-snug', titleCn]);
  const subtitleClassNames = classNames(['leading-snug', 'text-slate-500', 'truncate', subtitleCn]);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div data-component="UserInfo" className={cn} {...props}>
      <Avatar
        src={avatarSrc}
        initials={avatarInitials}
        alt={subtitle ? `${title} - ${subtitle}` : `${title}`}
        size={avatarSize}
        isOnline={isOnline}
        deactivated={deactivated}
        className="flex-none"
      />
      <div className="overflow-hidden ml-3 font-normal">
        <div className={titleClassNames}>{title}</div>
        <div className={subtitleClassNames}>
          {typeof subtitle === 'function' ? subtitle() : subtitle}
        </div>
        {role && <div className="truncate text-slate-500 text-sm">{role}</div>}
      </div>
    </div>
  );
};

UserInfo.defaultProps = {
  avatarSrc: null,
  avatarInitials: null,
  avatarSize: null,
  subtitle: null,
  isOnline: false,
  deactivated: false,
  children: null,
  role: null,
  className: null,
  titleCn: 'truncate',
  subtitleCn: 'text-sm',
};

UserInfo.propTypes = {
  avatarSrc: Avatar.propTypes.src,
  avatarInitials: Avatar.propTypes.initials,
  avatarSize: Avatar.propTypes.size,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  isOnline: PropTypes.bool,
  deactivated: PropTypes.bool,
  children: PropTypes.node,
  role: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  titleCn: PropTypes.string,
  subtitleCn: PropTypes.string,
};

export default UserInfo;
